<template>
    <div class="minidiv">
      <div class="flex-parent text-center p-1">
        <p class="flex-child">{{ sn + (page - 1) * interval }}</p>
        <p class="flex-child">{{ referral.ref_name }}</p>
        <!-- <p class="flex-child">{{ referral.ref_email }}</p> -->
        <p class="flex-child">{{ referral.date_registered }}</p>
        <p class="flex-child status" :class="{ 'used-class' : referral.upgraded == 'Yes', 'un-used' : referral.upgraded == 'No' }">{{ referral.upgraded }}</p>
        <p class="flex-child">{{ referral.amount_paid }}</p>
        <p class="flex-child">{{ referral.commission }}</p>
        <p class="flex-child">{{ referral.date_upgraded }}</p>
        
        
      </div>
    </div>
  </template>
  
  <script>
  import { mapActions, mapState } from "vuex";
  
  export default {
    props: ["referral", "sn", "page", "interval"],
    data() {
      return {
        overallscore: 0
      };
    },
    created() {},
    methods: {
      ...mapActions("admin", ["delreferral", "fetchreferrals"]),
      comfirmDelete() {
        this.$bvModal.show(`modal-remove_${this.sn}`);
      },
      deletereferral() {
        let referralObj = {
          trackid: this.referral.trackid
        };
  
        // console.log(referralObj);
  
        return this.delreferral(referralObj).then(() => {
          this.fetchreferrals();
          // console.log(response)
        });
      }
    },
    computed: {
      ...mapState({
        allinstitutions: state => state.admin.listinstitutions,
        details: state => state.loginmaster.details
      })
    }
  };
  </script>
  
  <style scoped>
  .minidiv {
    border-radius: 10px 10px;
    background-color: white;
    /* padding: 5px; */
  }
  
  .rins {
    font-size: 0.75rem;
  }
  
  .lowscore {
    color: red;
  }
  
  .highscore {
    color: #00377b;
  }
  
  .totsco {
    color: #00377b;
    font-weight: bolder;
  }
  
  .brel {
    text-decoration: none;
    color: black;
  }
  .link-sol {
    text-decoration: none;
    color: #00984a;
  }
  
  .flex-parent {
    display: flex;
    flex-flow: row wrap;
    overflow: auto;
    scrollbar-width: thin;
    /* height: 35px; */
  }
  
  .flex-child {
    width: 14%;
    overflow: auto;
    scrollbar-width: thin;
  }
  
  .status {
      padding : 5px 5px;
      border-radius : 10px 10px;
  }
  
  .un-used{
      background-color : rgba(239, 207, 45, 0.089);
      color : rgb(178, 151, 16)
  }
  
  .used-class{
      background-color :#2ee98846;
      color : #0f5d33;
  }
  @media screen and (max-width: 768px) {
    .flex-child {
      font-size: 0.6rem;
    }
    .link-sol {
      font-size: 0.7rem;
    }
    .list-button {
      width: contain;
      font-size: 0.6rem;
      padding: 3px;
    }
    .status{
        width: fit-content;
        height: fit-content;
    }
  }
  </style>
  